module.exports = __webpack_public_path__ + "img/COMP_RED.b634d7cf.svg";